const STATE_SYNC = "__histoire:state-sync";
const SANDBOX_READY = "__histoire:sandbox-ready";
const EVENT_SEND = "__histoire:event";
const PREVIEW_SETTINGS_SYNC = "__histoire:preview-settings-sync";
export {
  EVENT_SEND,
  PREVIEW_SETTINGS_SYNC,
  SANDBOX_READY,
  STATE_SYNC
};
